import { Theme } from '@mui/material/styles';
import { rowHeight } from 'utils/staticOptions';

export default function DataGrid(theme: Theme) {
  return {
    MuiDataGrid: {
      defaultProps: {
        hideFooter: true,
        rowHeight: rowHeight,
        columnHeaderHeight: rowHeight
      },
      styleOverrides: {
        root: {
          border: 'none',
          '& *:not(svg)': { fontSize: '0.75rem' },
          '& .MuiSvgIcon-fontSizeSmall': { fontSize: '1.25rem' },
          '& .anticon': { fontSize: '0.85rem' },
          '& .MuiDataGrid-cell:focus': { outline: 'none' },
          '& .MuiDataGrid-cell--editing:focus-within': { outline: 'none !important' },
          '& .MuiInputBase-root': {
            borderRadius: 0,
            boxShadow: 'none !important',
            fontSize: 'unset'
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': { border: 'none', boxShadow: 'none !important' },
            '&:hover fieldset': { border: 'none' },
            '&.Mui-focused fieldset': { border: 'none' }
          },
          '& .MuiDataGrid-booleanCell': {
            color: `${theme.palette.success.main} !important`,
            fontSize: '1.4rem'
          },
          '& .hidden .MuiDataGrid-booleanCell': { display: 'none' },
          '& .anticon-check-square': { top: '0 !important', left: '0 !important' }
        }
      }
    }
  };
}
